<template>
  <div class="accommodation-charge-view" :class="{ 'is-overlay': overlay }">
    <v-card class="list-card d-flex flex-column overflow-x-hidden overflow-y-auto" :tile="isShowEditingOverlay" style="position: relative;">
      <v-card-title
        class="text-center d-block py-2"
        @click="headerClicked"
      >
        {{ dateSelectionTitle }}
      </v-card-title>
      <v-btn
        v-if="accommodationChargesSelected.length > 0 || (overlay && isOpen)"
        icon
        style="position: absolute; right: 6px; top: 6px;"
        @click="close"
      >
        <v-icon>
          mdi-close
        </v-icon>
      </v-btn>
      <template v-if="accommodationChargesSelected.length > 0">
        <template v-if="hasNoChargesInSelectedDates">
          <v-alert
            dense
            text
            type="info"
            class="d-block mx-4 mt-2"
          >
            <div class="d-flex">
              <div class="flex-grow-1 my-auto">
                Det finns inga platsavgifter under vald period
              </div>
            </div>
          </v-alert>
        </template>
        <template v-else-if="hasDaysWithoutCharges">
          <v-alert
            dense
            text
            type="info"
            class="d-block mx-4 mt-2"
          >
            <div class="d-flex">
              <div class="flex-grow-1 my-auto">
                Det finns dagar utan platsavgifter under vald period
              </div>
            </div>
          </v-alert>
        </template>
        <template v-else-if="hasDaysWithMultiNightCharges">
          <v-alert
            dense
            text
            type="info"
            class="d-block mx-4 mt-2"
          >
            <div class="d-flex">
              <div class="flex-grow-1 my-auto">
                Perioden innehåller platsavgifter som avser flera nätter
              </div>
            </div>
          </v-alert>
        </template>
        <template v-else>
          <v-list dense class="py-0">
            <v-list-item two-line>
              <v-list-item-content>
                <v-list-item-title>{{ positionNameSelectedCharges }}</v-list-item-title>
                <v-list-item-subtitle>Plats</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            <v-list-item v-if="!!noteSelectedCharges" two-line>
              <v-list-item-content>
                <v-list-item-title>{{ noteSelectedCharges }}</v-list-item-title>
                <v-list-item-subtitle>Notering</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            <v-list-item two-line>
              <v-list-item-content>
                <v-list-item-title>{{ priceSelectedCharges }}</v-list-item-title>
                <v-list-item-subtitle>{{ priceLabel }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            <v-list-item two-line>
              <v-list-item-content>
                <v-list-item-title>{{ discountSelectedCharges }}</v-list-item-title>
                <v-list-item-subtitle>Rabatt</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </template>

        <div class="mx-4 mb-4 mt-auto">
          <template v-if="hasNoChargesInSelectedDates">
            <v-btn
              v-if="selectedDates.length > 1"
              @click="startNewPeriodAccommodationCharge"
              color="success"
              block
              outlined
              :disabled="hasDaysWithMultiNightCharges"
              class="mb-3"
            >
              Skapa periodpris
            </v-btn>
            <v-btn
              @click="startEditCharges"
              color="success"
              block
              :disabled="hasDaysWithMultiNightCharges"
            >
              {{ createChargesButtonText }}
            </v-btn>
          </template>
          <template v-else>
            <v-btn
              v-if="selectionIsMultiNightCharge"
              @click="splitMultiNightCharge"
              block
              outlined
              small
              class="mb-3"
              color="primary"
            >
              <v-icon class="mr-4" small>mdi-call-split</v-icon>
              Splitta till dygnspris
            </v-btn>
            <template v-if="hasNoPricesInSelectedCharges">
              <v-btn
                v-if="selectedDates.length > 1"
                @click="startNewPeriodAccommodationCharge"
                color="success"
                block
                outlined
                :disabled="hasDaysWithMultiNightCharges"
                class="mb-3"
              >
                Skapa periodpris
              </v-btn>
            </template>
            <template v-else>
              <v-btn
                @click="deleteCharges"
                :loading="isDeletingCharges"
                color="error"
                block
                outlined
                class="mb-3"
                small
              >
                <v-icon class="mr-4" small>mdi-delete</v-icon>
                {{ deleteChargesButtonText }}
              </v-btn>
            </template>
            <v-btn
              @click="startEditCharges"
              color="success"
              block
              :disabled="hasDaysWithMultiNightCharges"
            >
              <v-icon class="mr-4" small>mdi-pen</v-icon>
              {{ editChargesButtonText }}
            </v-btn>
          </template>
        </div>
      </template>
      <template v-else>
        <!-- Inga valda datum -->
        <div class="full-height d-flex flex-column px-4">
          <div v-if="!!accommodationSums">
            <v-list dense>
              <v-list-item two-line>
                <v-list-item-content>
                  <v-list-item-title>{{ totalAccommodationAmount }}</v-list-item-title>
                  <v-list-item-subtitle>Totala platsavgifter</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-list-item two-line>
                <v-list-item-content>
                  <v-list-item-title>{{ paidAccommodationAmount }}</v-list-item-title>
                  <v-list-item-subtitle>Betalt/fakturerat</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-list-item two-line>
                <v-list-item-content>
                  <v-list-item-title>{{ remainingAccommodationAmount }}</v-list-item-title>
                  <v-list-item-subtitle>Platsavgifter att betala</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </div>
          <v-alert
            dense
            text
            type="info"
            class="d-block mt-auto"
          >
            <div class="d-flex">
              <div class="flex-grow-1 my-auto">
                Välj datum i kalendern för att redigera platsavgifter. Du kan dra med muspekaren för att markera flera datum att redigera samtidigt.
              </div>
            </div>
          </v-alert>
        </div>
      </template>

      <div v-if="!!editedCharge" class="d-flex flex-column overflow-hidden" style="position: absolute; height: 100%; width: 100%; top: 0; left: 0; pointer-events: none; z-index: 2;">
        <v-fade-transition>
          <div @click="closeEditingOverlay" v-show="isShowEditingOverlay" style="height: 48px; opacity: 0.23; background-color: rgb(33, 33, 33); pointer-events: auto;"></div>
        </v-fade-transition>
        <v-scroll-y-reverse-transition>
          <div v-show="isShowEditingOverlay" class="flex-grow-1">
            <v-card class="full-height d-flex flex-column" style="pointer-events: auto;">
              <v-toolbar class="flex-shrink-1 flex-grow-0" flat>
                <div class="d-flex">
                  <v-toolbar-title class="headline">{{ editingHeadline }}</v-toolbar-title>
                </div>
                <v-spacer></v-spacer>
                <v-btn icon @click="closeEditingOverlay">
                  <v-icon>
                    mdi-close
                  </v-icon>
                </v-btn>
              </v-toolbar>
              <div class="flex-grow-1 px-7 pt-3">
                <price-input
                  v-model="editedCharge"
                  :three-rows="!overlay"
                  dense
                  :error-messages="priceErrorMessages"
                  @updated-price="validatePrice"
                ></price-input>
              </div>
              <v-card-actions class="pa-4">
                <v-spacer></v-spacer>
                <v-btn
                  color="success"
                  @click="saveEditedCharge"
                  :loading="isSavingEditedCharge"
                >
                  Spara
                </v-btn>
              </v-card-actions>
            </v-card>
          </div>
        </v-scroll-y-reverse-transition>
      </div>
    </v-card>
  </div>
</template>

<script>
import PriceInput from '@/components/product/PriceInput.vue'

export default {
  name: 'AccommodationChargeView',
  components: {
    PriceInput
  },
  props: {
    overlay: Boolean,
    isOpen: Boolean,
    booking: Object,
    calendarItems: Array,
    accommodationSums: Object,
    loading: Boolean,
    selectedDates: Array
  },
  data: () => ({
    isShowEditingOverlay: false,
    editedCharge: null,
    isSavingEditedCharge: false,
    isDeletingCharges: false,
    savingDates: [],
    priceError: ''
  }),
  computed: {
    createChargesButtonText: function () {
      if (this.selectedDates.length === 1) {
        return 'Skapa platsavgift'
      } else {
        return 'Skapa platsavgifter'
      }
    },
    editChargesButtonText: function () {
      if (this.selectionIsMultiNightCharge) {
        return 'Redigera periodpris'
      } else if (this.selectedDates.length > 1) {
        return 'Redigera platsavgifter'
      } else {
        return 'Redigera platsavgift'
      }
    },
    deleteChargesButtonText: function () {
      if (this.selectionIsMultiNightCharge) {
        return 'Ta bort periodpris'
      } else if (this.selectedDates.length === 1) {
        return 'Ta bort platsavgift'
      } else {
        return 'Ta bort platsavgifter'
      }
    },
    editingHeadline: function () {
      if (!this.editedCharge) {
        return ''
      }
      if (this.hasNoChargesInSelectedDates) {
        // Skapar nya charges, ingen charge vald
        if (this.editedCharge.is_period_accommodation_charge) {
          return 'Skapa periodpris'
        } else if (this.selectedDates.length > 1) {
          return 'Skapa platsavgifter'
        } else {
          return 'Skapa platsavgift'
        }
      }
      if (this.editedCharge.is_period_accommodation_charge) {
        return 'Redigera periodpris'
      } else if (this.selectedDates.length > 1) {
        return 'Redigera platsavgifter'
      } else {
        return 'Redigera platsavgift'
      }
    },
    dateSelectionTitle: function () {
      if (this.selectedDates.length === 1) {
        const firstDate = window.dayjs.parseDate(this.selectedDates[0])
        return `${firstDate.format('D MMM YYYY')}`
      } else if (this.selectedDates.length > 1) {
        const firstDate = window.dayjs.parseDate(this.selectedDates[0])
        const lastDate = window.dayjs.parseDate(this.selectedDates[this.selectedDates.length - 1])
        return `${firstDate.format('D MMM YYYY')} - ${lastDate.format('D MMM YYYY')}`
      }
      return ''
    },
    accommodationChargesSelected: function () {
      if (this.selectedDates.length === 0) {
        return []
      }
      const accommodationCharges = []
      this.selectedDates.forEach(date => {
        const calendarItem = this.calendarItems.find(ci => ci.date === date)
        if (calendarItem?.accommodation_charge) {
          if (accommodationCharges.findIndex(ac => !!ac && ac.id === calendarItem.accommodation_charge.id) === -1) {
            // Lägger inte till accommodationCharge om det redan finns accommodationCharge med samma id
            accommodationCharges.push(calendarItem.accommodation_charge)
          }
        } else {
          accommodationCharges.push(null)
        }
      })
      return accommodationCharges
    },
    suggestedAccommodationCharges: function () {
      return this.calendarItems.map(ci => ci.suggested_accommodation_charge).filter(ci => !!ci)
    },
    allAccommodationCharges: function () {
      return this.calendarItems.map(ci => ci.accommodation_charge).filter(ci => !!ci)
    },
    hasNoChargesInSelectedDates: function () {
      // inga accommodation charges under valda datum
      return this.accommodationChargesSelected.filter(ac => !!ac).length === 0
    },
    hasNoPricesInSelectedCharges: function () {
      // alla valda accommodation charges saknar pris
      return this.accommodationChargesSelected.filter(ac => !!ac && ac.price > 0).length === 0
    },
    hasDaysWithoutCharges: function () {
      // finns dagar utan accommodation charges
      return this.accommodationChargesSelected.filter(ac => !ac).length > 0
    },
    hasDaysWithMultiNightCharges: function () {
      const hasMultiNightCharges = this.accommodationChargesSelected.filter(ac => !!ac && ac.nights > 1).length > 0
      return hasMultiNightCharges && this.accommodationChargesSelected.length > 1
    },
    priceLabel: function () {
      const hasMultiNightCharges = this.accommodationChargesSelected.filter(ac => !!ac && ac.nights > 1).length > 0
      if (hasMultiNightCharges) {
        return 'Pris'
      }
      return 'Pris / natt'
    },
    positionNameSelectedCharges: function () {
      if (this.accommodationChargesSelected.length === 0) {
        return ''
      }
      const isSamePosition = this.accommodationChargesSelected.every(ac => ac.position_id === this.accommodationChargesSelected[0].position_id)
      if (!isSamePosition) {
        return 'Olika platser'
      }
      if (this.accommodationChargesSelected[0].position) {
        return this.accommodationChargesSelected[0].position.full_name
      } else {
        return 'Okänd plats' // platsen kan ha tagits bort
      }
    },
    noteSelectedCharges: function () {
      if (this.accommodationChargesSelected.length === 0) {
        return null
      }
      const isSameNote = this.accommodationChargesSelected.every(ac => ac.note === this.accommodationChargesSelected[0].note)
      if (!isSameNote) {
        return 'Olika noteringar'
      }
      if (this.accommodationChargesSelected[0].note === '' || this.accommodationChargesSelected[0].note === null) {
        return null
      }
      return this.accommodationChargesSelected[0].note
    },
    priceSelectedCharges: function () {
      if (this.accommodationChargesSelected.length === 0) {
        return ''
      }
      const isSamePrice = this.accommodationChargesSelected.every(ac => ac.price === this.accommodationChargesSelected[0].price)
      if (!isSamePrice) {
        return 'Olika priser'
      }
      const price = this.accommodationChargesSelected[0].price / 100
      return window.conversion.toHumanReadableAmount(price)
    },
    discountSelectedCharges: function () {
      if (this.accommodationChargesSelected.length === 0) {
        return ''
      }
      const isSameDiscount = this.accommodationChargesSelected.every(ac => ac.discount_type === this.accommodationChargesSelected[0].discount_type && ac.discount_value === this.accommodationChargesSelected[0].discount_value && ac.discount_name === this.accommodationChargesSelected[0].discount_name)
      if (!isSameDiscount) {
        return 'Olika rabatter'
      }
      const discountName = this.accommodationChargesSelected[0].discount_name
      const discountNameSuffix = discountName ? ` (${discountName})` : ''
      const discountValue = this.accommodationChargesSelected[0].discount_value / 100
      if (this.accommodationChargesSelected[0].discount_type === 'flat') {
        return `${discountValue}kr rabatt${discountNameSuffix}`
      } else if (this.accommodationChargesSelected[0].discount_type === 'fixed') {
        return `Nedsatt från ${this.accommodationChargesSelected[0].original_price / 100}kr${discountNameSuffix}`
      } else if (this.accommodationChargesSelected[0].discount_type === 'percent') {
        return `${discountValue}% rabatt${discountNameSuffix}`
      }
      return 'Ingen rabatt'
    },
    priceErrorMessages: function () {
      if (this.priceError === '') {
        return []
      }
      return [this.priceError]
    },
    selectionIsMultiNightCharge: function () {
      // true om man valt ett periodpris, och inget annat
      if (
        this.accommodationChargesSelected.length !== 1 ||
        this.accommodationChargesSelected[0] === null ||
        this.accommodationChargesSelected[0].nights <= 1 ||
        this.selectedDates.length !== this.accommodationChargesSelected[0].nights
      ) {
        return false
      }
      // Gör extra kontroll för säkerhets skull
      if (this.accommodationChargesSelected[0].start.format('YYYY-MM-DD') !== this.selectedDates[0] ||
      this.accommodationChargesSelected[0].end.add(-1, 'days').format('YYYY-MM-DD') !== this.selectedDates[this.selectedDates.length - 1]) {
        return false
      }
      return true
    },
    totalAccommodationAmount: function () {
      if (!this.accommodationSums) {
        return '-'
      }
      return window.conversion.toHumanReadableAmount(this.accommodationSums.total_accommodation_amount / 100)
    },
    paidAccommodationAmount: function () {
      if (!this.accommodationSums) {
        return '-'
      }
      return window.conversion.toHumanReadableAmount(this.accommodationSums.paid_accommodation_amount / 100)
    },
    remainingAccommodationAmount: function () {
      if (!this.accommodationSums) {
        return '-'
      }
      return window.conversion.toHumanReadableAmount(this.accommodationSums.remaining_accommodation_amount / 100)
    }
  },
  methods: {
    closeEditingOverlay: function () {
      this.isShowEditingOverlay = false
    },
    close: function () {
      if (this.overlay) {
        this.$emit('close')
      } else {
        this.unselectDateRange()
      }
    },
    splitMultiNightCharge: function () {
      if (!this.selectionIsMultiNightCharge) {
        return false
      }
      // valt en period med en accommodation charge med flera nätter, och inga andra datum, vi delar upp denna perioden på flera accommodation charges
      const multiNightCharge = this.accommodationChargesSelected[0]
      const newPrice = Math.round(multiNightCharge.price / multiNightCharge.nights)
      this.editedCharge = {
        id: 0,
        is_period_accommodation_charge: false,
        quantity: 1,
        discount_name: null,
        discount_type: null,
        discount_value: 0,
        price: newPrice,
        original_price: newPrice,
        note: ''
      }
      this.saveEditedCharge()
    },
    deleteCharges: function () {
      this.editedCharge = {
        id: 0,
        is_period_accommodation_charge: false,
        quantity: 1,
        discount_name: null,
        discount_type: null,
        discount_value: 0,
        price: 0,
        original_price: 0,
        note: ''
      }

      this.isDeletingCharges = true
      this.saveEditedCharge()
        .finally(() => {
          this.isDeletingCharges = false
        })
    },
    startNewPeriodAccommodationCharge: function () {
      this.editedCharge = {
        id: 0,
        is_period_accommodation_charge: true,
        quantity: 1,
        discount_name: null,
        discount_type: null,
        discount_value: 0,
        price: 0,
        original_price: 0,
        note: ''
      }

      this.isShowEditingOverlay = true
    },
    startEditCharges: function () {
      const firstAccommodationCharge = this.accommodationChargesSelected[0]
      if (this.selectionIsMultiNightCharge) {
        // valt en period med en accommodation charge med flera nätter, och inga andra datum
        this.editedCharge = {
          id: firstAccommodationCharge.id,
          is_period_accommodation_charge: true,
          quantity: 1,
          discount_name: firstAccommodationCharge.discount_name,
          discount_type: firstAccommodationCharge.discount_type,
          discount_value: firstAccommodationCharge.discount_value,
          price: firstAccommodationCharge.price,
          original_price: firstAccommodationCharge.original_price,
          note: ''
        }
      } else if (this.accommodationChargesSelected.length === 1) {
        if (firstAccommodationCharge === null) {
          // Redigerar en dag utan accommodation charge
          this.editedCharge = {
            id: 0,
            is_period_accommodation_charge: false,
            quantity: 1,
            discount_name: null,
            discount_type: null,
            discount_value: 0,
            price: 0,
            original_price: 0,
            note: ''
          }
        } else {
          // Redigerar en dag med accommodation charge
          this.editedCharge = {
            id: firstAccommodationCharge.id,
            is_period_accommodation_charge: false,
            quantity: 1,
            discount_name: firstAccommodationCharge.discount_name,
            discount_type: firstAccommodationCharge.discount_type,
            discount_value: firstAccommodationCharge.discount_value,
            price: firstAccommodationCharge.price,
            original_price: firstAccommodationCharge.original_price,
            note: ''
          }
        }
      } else {
        // Valt flera dagar
        if (this.hasDaysWithoutCharges) {
          // Finns dagar utan charges
          this.editedCharge = {
            id: 0,
            is_period_accommodation_charge: false,
            quantity: 1,
            discount_name: null,
            discount_type: null,
            discount_value: 0,
            price: 0,
            original_price: 0,
            note: ''
          }
        } else {
          // Flera dagar, och alla har charges
          const isSamePrice = this.accommodationChargesSelected.every(ac => ac.price === this.accommodationChargesSelected[0].price)
          const isSameDiscount = this.accommodationChargesSelected.every(ac => ac.discount_type === this.accommodationChargesSelected[0].discount_type && ac.discount_value === this.accommodationChargesSelected[0].discount_value && ac.discount_name === this.accommodationChargesSelected[0].discount_name)
          const price = isSamePrice ? firstAccommodationCharge.price : 0
          this.editedCharge = {
            id: 0,
            is_period_accommodation_charge: false,
            quantity: 1,
            discount_name: isSameDiscount ? firstAccommodationCharge.discount_name : null,
            discount_type: isSameDiscount ? firstAccommodationCharge.discount_type : null,
            discount_value: isSameDiscount ? firstAccommodationCharge.discount_value : null,
            price,
            original_price: price,
            note: ''
          }
        }
      }
      this.validatePrice()

      this.isShowEditingOverlay = true
    },
    validatePrice: function () {
      if (this.editedCharge.price === '' || this.editedCharge.price === null || this.editedCharge.price === undefined) {
        this.priceError = 'Ange ett pris'
        return false
      } else if (this.editedCharge.price < 0) {
        // negativa priser är inte tillåtet
        this.priceError = 'En vara kan inte ha negativt pris, ange ett negativt antal för att göra returer'
        return false
      } else {
        // Tillåter högre pris än original_price
        this.priceError = ''
        return true
      }
    },
    unselectDateRange: function () {
      this.$emit('unselect-dates')
    },
    headerClicked: function () {
      this.$emit('header-clicked')
    },
    saveEditedCharge: function () {
      const bookingId = this.booking.id

      if (!this.validatePrice()) {
        return false
      }

      this.isSavingEditedCharge = true

      // Lägger till laddningsanimationer
      const selectedDates = this.selectedDates.slice() // close() nollställer selectedDates, tar därför en kopia först
      selectedDates.forEach(dt => {
        this.savingDates.push(dt)
      })
      if (this.overlay) {
        this.close()
      }

      return this.$store.dispatch('booking/saveAccommodationCharges', {
        bookingId,
        dates: selectedDates,
        isPeriodAccommodationCharge: this.editedCharge.is_period_accommodation_charge,
        price: this.editedCharge.price,
        discountName: this.editedCharge.discount_name,
        discountType: this.editedCharge.discount_type,
        discountValue: this.editedCharge.discount_value,
        originalPrice: this.editedCharge.original_price
      })
        .then(() => {
          this.isSavingEditedCharge = false
          this.isShowEditingOverlay = false
          // Tar bort laddningsanimationer
          selectedDates.forEach(dt => {
            const i = this.savingDates.findIndex(d => d === dt)
            if (i >= 0) {
              this.savingDates.splice(i, 1)
            }
          })
        })
    }
  },
  watch: {
    savingDates: function () {
      this.$emit('set-saving-dates', this.savingDates)
    },
    selectedDates: function () {
      this.isShowEditingOverlay = false
    }
  }
}
</script>
